import MaterialBase from './MaterialBase';

class Prepreg extends MaterialBase {
}

Prepreg.displayName = 'Prepreg';

Prepreg.defaultProps = {
  color: 0x00ff00,
};

export default Prepreg;



// WEBPACK FOOTER //
// ./src/components/common/materials/Prepreg.js